import Vue from 'vue';
import axios from 'axios'; 
import '../../filters';
import moment from 'moment';

export default {
  name: 'Disconnections',
  components: {
    DisconnectionComp: require('./disconnection.vue').default,
  },
  data: function () {
    return {
      disconns: [],
      editingDisconnection: {},
      groups: [],
      projects: [],
      batches: [],
      statuses: [],
      message: '',
      showFilters: false,
      search: '',
      paginationEnabled: this.$localStorage.get("Disconnections Pagination") === 'true' ? true : false,
      pageSizeNonPagination: 100,
      pageSizePagination: 10,
      options: { total: 0, page: 1, pageSize: this.paginationEnabled ? this.pageSizePagination : this.pageSizeNonPagination, from: null, to: null },
      billingGroupId: '-1',
      projectId: -1,
      batchId: -1,
      statusId: 1,
      showDisconnection: false,
      bIsLoading: false,
      totalRow: 0,
      bIsAllowDisconReconWithoutReading: false,
    }
  },
  watch: {
    paginationEnabled: function (val) {
      //save to cookies
      this.$localStorage.set("Disconnections Pagination", val);

      if (!this.paginationEnabled)
        this.$alertMsg(this.$t('disconnections.nonPaginationInfo'), 1)

      this.pageChange({ pageNumber: 1, pageSize: this.paginationEnabled ? this.pageSizePagination : this.pageSizeNonPagination });
    },
    search: function (value) {
      this.getDisconnections();
    },
    billingGroupId: function (value) {
      this.getDisconnections();
    },
    projectId: function (value) {
      this.getDisconnections();
    },
    batchId: function (value) {
      this.getDisconnections();
    },
    statusId: function (value) {
      this.getDisconnections();
    }
  },
  created() {
    this.getDmActivityPropertyStatuses();
    this.getBillingGroups();
    this.getProjects();
    this.getBatches();
  },
  mounted() {
    if (!this.paginationEnabled)
     this.$alertMsg(this.$t('disconnections.nonPaginationInfo'), 1)
  },
  methods: {
    clearFilters() {
      this.billingGroupId = '-1';
      this.projectId = '-1';
      this.batchId = '-1';
      this.statusId = '1';
      this.getDisconnections();
    },
    pageChange(pInfo) {

      var parameters = {
        Options: {
          PageSize: this.paginationEnabled ? pInfo.pageSize : this.pageSizeNonPagination,
          Page: pInfo.pageNumber,
          FilterText: this.search
        },
        BillingGroupId: (this.billingGroupId == '-1' ? '' : this.billingGroupId),
        ProjectId: this.projectId,
        BatchNo: this.batchId,
        Status: this.statusId
      };
      //console.log("pageChange param", parameters.Options);
      this.getDisconnectionsAux(parameters);
    },
    formatCurrency(value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    getDisconnectionsAux(parameters) {
      if (this.bIsLoading===true)
        return;
      this.bIsLoading = true;
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/DmConnection/GetDisconnectionItems', parameters)
        .then(response => {
          this.bIsLoading = false;
          
          if (response.data.data.status == 0) {
            response.data.items.forEach((item) => {
              item.rowClass = 'disconnections';

              if (item.isUnderInvestigation===true)
                item.rowClass = 'investigation';

              if (item.finalReading > 0)
                item.rowClass = 'completed';
            });
            this.disconns = response.data.items;
            this.options.total = response.data.count;
            this.totalRow = response.data.count;
            this.pageSizeNonPagination = parseInt(response.data.count);
          }
          else {
           this.$alertMsg(response.data.data.text);
            this.options.total = 0;
          }

          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
        })
    },
    getDisconnections() {
      if (this.bIsLoading === true)
        return;
      this.bIsLoading = true;
      var parameter = {
        Options: {
          PageSize: this.paginationEnabled ? this.options.pageSize : this.pageSizeNonPagination,
          Page: this.options.page,
          FilterText: this.search },
        BillingGroupId: (this.billingGroupId == '-1'? '': this.billingGroupId),
        ProjectId: this.projectId,
        BatchNo: this.batchId,
        Status: this.statusId
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/DmConnection/GetDisconnectionItems', parameter)
        .then(response => {
          this.bIsLoading = false;
          if (response.data.data.status == 0) {
            response.data.items.forEach((item) => {
              item.rowClass = 'disconnections';

              if (item.isUnderInvestigation===true)
                item.rowClass = 'investigation';

              if (item.finalReading > 0)
                item.rowClass = 'completed';
            });
            this.disconns = response.data.items;
            this.options.total = response.data.count;
            this.pageSizeNonPagination = parseInt(response.data.count);
           // console.log("in", parameter);
          }
          else {
           this.$alertMsg(response.data.data.text);
            this.options.total = 0;
          }

          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
        })
    },
    getDmActivityPropertyStatuses() {
      axios.post('/DmConnection/GetDmActivityPropertyStatuses')
        .then(response => {
          if (response.data.data.status == 0) {
            this.statuses = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getBillingGroups() {
      axios.post('/DmConnection/GetBillingGroups')
        .then(response => {
          if (response.data.data.status == 0) {
            this.groups = response.data.items;
            this.groups.unshift({id:'-1', name:'ALL'});
          }
          else {
           this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getProjects() {
      axios.post('/DmConnection/GetProjects')
        .then(response => {
          if (response.data.data.status == 0) {
            this.projects = response.data.items;
            this.projects.unshift({ id: '-1', name: 'ALL' });
            this.projectId = '-1';
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getBatches() {
      var parameter = {
        BillingGroupId: (this.billingGroupId == '-1' ? '' : this.billingGroupId),
        ProjectId: this.projectId,
        Status: this.statusId
      };
      axios.post('/DmConnection/GetDisconnectionBatches', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.batches = response.data.items;
            this.batches.unshift({ id: '-1', name: 'ALL' });
            this.batchId = '-1';
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    editDisconnection(disconnection) {
      this.editingDisconnection = disconnection;
      this.editingDisconnection.finalReadingDateAux = this.editingDisconnection.finalReadingDate;
      this.editingDisconnection.readonly = false;
      this.editingDisconnection.offline = this.bWorkOffline;
      this.$root.$emit('disconnection_updated');
      this.showDisconnection = true;
    },
    putUnderInvestigation() {
      var parameter = {
        Account: this.editingDisconnection.account,
        CaseId: this.editingDisconnection.caseId,
        ConnectionId: this.editingDisconnection.connectionId
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/DmConnection/PutUnderInvestigation', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t('messages.DisconnSuccessSetUnderInvestigation'), 2);
          }
          else
            this.$alertMsg(response.data.data.text)

          loader.hide();
        })
        .catch((e) => { loader.hide(); this.$alertMsg(e.message) })
    },
    save() {
      if (this.editingDisconnection.isUnderInvestigation!==true) {
        this.saveDisconnection();
      }
      else {
        var parameter = {
          Account: this.editingDisconnection.account,
          CaseId: this.editingDisconnection.caseId,
          ConnectionId: this.editingDisconnection.connectionId,
          Comment: this.editingDisconnection.comment,
        };
        let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
        axios.post('/DmConnection/PutUnderInvestigation', parameter)
          .then(response => {
            if (response.data.data.status == 0) {
              this.$alertMsg(this.$t('messages.DisconnSuccessSetUnderInvestigation'), 2);
              this.getDisconnections();
            }
            else
              this.$alertMsg(response.data.data.text)

            loader.hide();
            this.showDisconnection = false;
          })
          .catch((e) => { loader.hide(); this.$alertMsg(e.message) })
      }
    },
    saveDisconnection() {
      var parameter = {
        Account: this.editingDisconnection.account,
        CaseId: this.editingDisconnection.caseId,
        ConnectionId: this.editingDisconnection.connectionId,
        FinalReading: this.editingDisconnection.finalReading,
        FinalReadingDate: this.editingDisconnection.finalReadingDate,
        FinalReadingClockOver: this.editingDisconnection.finalReadingClockOver,
        Comment: this.editingDisconnection.comment
      };

      if (parameter.FinalReadingDate === null)
        parameter.FinalReadingDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
      else
        parameter.FinalReadingDate = new Date(parameter.FinalReadingDate.getFullYear(), parameter.FinalReadingDate.getMonth(), parameter.FinalReadingDate.getDate() + 1);

      this.getSettings()
        .then(resp => {
          parameter['SkipMeterReading'] = this.bIsAllowDisconReconWithoutReading == true ? true : false;
          let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
          axios.post('/DmConnection/SetDisconnectionFinalReading', parameter)
            .then(response => {
              if (response.data.data.status == 0) {
                this.$alertMsg(this.$t('messages.DisconnSavedSuccess'), 2);
                this.editingDisconnection.finalReadingDate = parameter.FinalReadingDate;
                this.getDisconnections();
              }
              else
                this.$alertMsg(response.data.data.text)

              loader.hide();
              this.showDisconnection = false;
            })
            .catch((e) => { loader.hide(); this.$alertMsg(e.message) })
        });
    },
    closeDialog() {
      this.showDisconnection = false;
    },
    getSettings() {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      return axios.post('/DmConnection/GetSettings')
        .then(response => {

          if (response.data.data.status == 0) {
            this.bIsAllowDisconReconWithoutReading = response.data.value.isAllowDisconReconWithoutReading;
            loader.hide();
            return true;
          }
          else {
            this.$alertMsg(response.data.data.text);
            loader.hide();
            return false;
          }
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
        })
    },
    //onPagination(args) {
    //  this.options.page = args.page;
    //  this.options.pageSize = args.size;
    //  this.getDisconnections();
    //},
  },

}

